<div class="flex flex-col gap-6 w-full">
    <app-file-drop [multiple]="multiple" [fileTypes]="fileTypes" [maxFileSize]="maxFileSize"
        [existingFiles]="uploadedFiles" (uploadData)="onFileUpload($event)" (removeFile)="onRemoveFile($event)">
    </app-file-drop>

    @if(additionalActions.length) {
    <div class="flex flex-col gap-2">
        @for (action of additionalActions; track action.key) {
        <app-button [variant]="action.variant || 'outlined'" [severity]="action.severity || 'contrast'"
            [label]="action.label" [icon]="action.icon || ''" (clicked)="onAdditionalActionClick(action.key)" />
        }
    </div>
    }

    @if(!hideActionButtons) {
        <div class="flex items-end justify-end gap-2 mt-4">
            <app-button variant="outlined" severity="contrast" [label]="secondaryButtonLabel"
                (clicked)="onSecondaryAction()" />
            <app-button variant="filled" severity="primary" [label]="primaryButtonLabel" class="w-full sm:w-auto"
                (clicked)="onPrimaryAction()" [disabled]="uploadedFiles.length === 0 || primaryButtonLoading"
                [loading]="primaryButtonLoading" />
        </div>
    }
</div>